class TagFilter extends HTMLElement {
	constructor() {
		super();
	}

  connectedCallback() {
    this.addEventListener('mousewheel', (event) => { this.scrollHorizontally(event) });
    this.querySelectorAll('button')
      .forEach((button) => button.addEventListener('click', (event) => { this.updateTagFilter(event) }));
  }

  updateTagFilter(event) {
    var tag = event.target.dataset.tag;
    if(!tag) {
        return;
    }
  }

  scrollHorizontally(e) {
    e = window.event || e;
    var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
    this.scrollLeft -= (delta * 150);
    e.preventDefault();
  }
}

customElements.define('tag-filter', TagFilter);